//
//
//
//
//
//
//
//
//
//

export default {
  computed: {
    isLoading () {
      return this.$store.state.isLoading
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/components/Loading.vue